export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-5-057ebaa8fa7b9294a06247d6a6180326.webp";